import {
    UserController,
    ProductController,
    StripeController,
} from "controllers";

// getting the data
export const getMissingData = async (option, country) => {
    let data = (option === 'missing') ? await ProductController.getMissingItems(country) : await ProductController.getKeptItems(country);

    if (data.length !== 0) {
        data = await cleaning(data);
        data = await getLogs(data);
    };
    return data;
}

const cleaning = async (products) => {
    for (const product of products) {
        if (product.currentUser) {
            product.user = await UserController.getUserById(product.currentUser);
        }
    }
    return products
};

const getLogs = async (products) => {
    for (const product of products) {
        if (product.currentBox) {
            product.log = await ProductController.getLogByBoxId(product.barcode, product.currentBox);
        }
    }
    return products.sort(function (a, b) {
        // making sure that products will be ordered by user
        if (!a.log || !b.log) {
            return -1;
        } else {
            return a.log.addedToBox < b.log.addedToBox ? 1 : -1;
        }
    });
};

const updateAllStatuses = async (missingItem, status) => {
    const item = await UserController.getUserBoxItemByProductBarcode(missingItem.currentUser, missingItem.currentBox, missingItem.barcode);

    const { barcode, currentBox, currentUser } = missingItem;
    // update status of product (from 'missing' to 'kept')
    await ProductController.updateProductStatus(barcode, status);
    await ProductController.updateItem(currentUser, currentBox, item.id, { status: status });
    await ProductController.updateProductLog(barcode, currentBox, "declared_kept");
}

export const createItemPayload = async (missingItem, status) => {

    // if (!missingItem || missingItem?.user) {
    //     throw Error('Missing parameter missingItem');
    // }

    const customerId = missingItem.user.stripe.stripe_id;

    const itemPayload = { barcode: missingItem.barcode };

    if (customerId) {
        const country = localStorage.getItem('country');
        const result = await StripeController.createSingleItemSubscription(customerId, country);
        const subResult = result.data.result;

        // assigning results to payload
        itemPayload.subscription_id = subResult.id;
        itemPayload.status = subResult.status;
        itemPayload.created_at = subResult.created;
        itemPayload.created_from = 'Tidie';
    };

    return itemPayload;
}

const addStripeFields = async (missingItem) => {
    const { stripe } = missingItem.user;
    if (!stripe.single_item_subscriptions) {
        stripe.single_item_subscriptions = [];
    }
    const itemPayload = await createItemPayload(missingItem);
    stripe.single_item_subscriptions.push(itemPayload);
    const payload = { stripe };
    await UserController.addStripeSubscription(missingItem.currentUser, payload);
}

export const chargeSingleItem = async (missingItem) => {
    try {
        const status = "kept";
        await updateAllStatuses(missingItem, status);

        await addStripeFields(missingItem, status);
    } catch (error) {
        throw new Error(error.message);
    }
}

export const markAsInvestigate = async (missingItem) => {
    const { barcode, currentBox } = missingItem;
    try {
        await ProductController.updateProductLog(barcode, currentBox, "investigated")
    } catch (error) {
        throw new Error(error.message);
    };
}

export const getItemsByUsers = async (activeTab, field, search, market) => {
    const option = activeTab.toLowerCase();
    try {
        const users = await UserController.filterUsersByField(field, search, market);
        let results = [];
        for (const user of users) {
            const result = await ProductController.getItemsByFieldQuery({ option, search: user.id, market });
            results.push(...result);
        };
        if (results.length !== 0) {
            results = await cleaning(results);
            results = await getLogs(results);
        };
        return results;
    } catch (error) {
        throw new Error(error.message);
    };
}

export const getItemsByProducts = async (activeTab, field, query, country) => {
    const option = activeTab.toLowerCase();
    try {
        const products = await ProductController.getProductByFieldQuery(field, query, 50, country);
        let results = [];
        for (const product of products) {
            if (product.status === option) {
                results.push(product);
            };
        };
        if (results.length !== 0) {
            results = await cleaning(results);
            results = await getLogs(results);
        };
        return results;
    } catch (error) {
        console.log(error)
        throw new Error(error.message);
    };
};

